import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { Theme, THEME_TOKEN } from '../../types/theme.types';
import { componentStylesByTheme } from '../../utils/theme.utils';
import { style } from '../../utils/style.utils';
import {
  avatarNameLabelStylesSAG,
  avatarNameLabelStylesSHS,
} from './avatar-name.styles';

@Directive({
  selector: '[sag-ui-avatar-name]',
})
export class AvatarNameDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLSpanElement>
  ) {}

  ngOnInit(): void {
    const avatarNameLabelStyles = componentStylesByTheme(
      this.theme,
      avatarNameLabelStylesSAG,
      avatarNameLabelStylesSHS
    );
    style(this.elementRef, avatarNameLabelStyles());
  }
}
